import React from 'react';
import get from 'utils/get';

import BlockText from 'components/BlockText';
import BlockQuote from 'components/BlockQuote';
import BlockImage from 'components/BlockImage';
import BlockDoubleImage from 'components/BlockDoubleImage';
import BlockAudio from 'components/BlockAudio';
import BlockImageText from 'components/BlockImageText';
import BlockVideo from 'components/BlockVideo';

const BlockSwitch = props => {
  const {
    block,
    currentLaureate,
    isFirst,
    backgroundLineKeywords
  } = props;

  const type = get(block, 'sys.contentType.sys.id');

  const Block = type => {
    switch (type) {
      case 'blockText':
        return (
          <BlockText
            block={block}
            currentLaureate={currentLaureate}
            hasSocialLinks={isFirst}
            backgroundLineKeywords={backgroundLineKeywords}
          />
        );
      case 'blockQuote':
        return <BlockQuote block={block} />;
      case 'blockImage':
        return <BlockImage block={block} />;
      case 'blockDoubleImage':
        return <BlockDoubleImage block={block} />;
      case 'blockAudio':
        return <BlockAudio block={block} />;
      case 'blockImageText':
        return (
          <BlockImageText
            block={block}
            currentLaureate={currentLaureate}
            backgroundLineKeywords={backgroundLineKeywords}
          />
        );
      case 'blockVideo':
        return <BlockVideo block={block} />;
      default:
        return null;
    }
  };

  return Block(type);
};

export default BlockSwitch;
